<template>
    <footer class="row row-cols-1 row-cols-sm-2 row-cols-md-5 py-3 my-3 border-top bg-white">
        <div class="col mb-6">
            <router-link to="/" class="d-flex align-items-center mb-3 link-dark text-decoration-none">
                <img src="../assets/logo.png" alt="Logo">
            </router-link>
            <p class="text-muted">© {{ year }} Sistemas - WC</p>
        </div>

        <div class="col mb-3">

        </div>

        <div class="col mb-3">
            
        </div>

        <div class="col mb-3">
            <h5>Contacto</h5>
            <ul class="nav flex-column">
                <li class="nav-item mb-2"><i class="fa fa-envelope"></i> wiljcc6@gmail.com</li>
                <li class="nav-item mb-2"><i class="fa fa-mobile"></i> +57 3177858446</li>
                <li class="nav-item mb-2"><i class="fa fa-map-marker"></i> Colombia</li>
            </ul>
        </div>
    </footer>
</template>

<script>
    export default {
        data: () => ({
            year: new Date().getFullYear()
        })
    }
</script>

<style scoped>
    img{
        width: 18%;
    }
</style>